var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import salesReportingURL from "@adapters/infrastructures/urlConfig/SalesJourney/Reporting/SalesReportingURL";
import { SalesMTFReportMapper } from "@domains/salesFeatures/SalesReporting/mapper/SalesMTFReportMapper";
import { SalesHolidayListMapper } from "@domains/salesFeatures/SalesReporting/mapper/SalesHolidayListMapper";
import { SalesAllReportMapper } from "@domains/salesFeatures/SalesReporting/mapper/SalesAllReportMapper";
import { SalesPaginatedListReportMapper } from "@domains/salesFeatures/SalesReporting/mapper/SalesPaginatedReportMapper";
import supersetReportingURL from "@adapters/infrastructures/urlConfig/SalesJourney/Reporting/SupersetReportingURL";
var SalesReportingRepo = /** @class */ (function () {
    function SalesReportingRepo(http) {
        this.http = http;
    }
    SalesReportingRepo.prototype.getReportData = function (req) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, result, reportEntity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = new URL(salesReportingURL.reportMainData);
                        url.searchParams.append("isDownload", req.isDownload ? "true" : "false");
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req.mainReqBody,
                            })];
                    case 1:
                        result = _b.sent();
                        reportEntity = {
                            currentpage: result.currentpage,
                            pagesize: result.pagesize,
                            totalpages: result.totalpages,
                            totalitems: result.totalitems,
                        };
                        if ((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.isDownload) {
                            reportEntity.isDownloadData = result.data;
                        }
                        else {
                            reportEntity.tabledata = result === null || result === void 0 ? void 0 : result.data;
                        }
                        return [2 /*return*/, reportEntity];
                }
            });
        });
    };
    SalesReportingRepo.prototype.getPaginatedListParamsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesReportingURL.getPaginatedListOfReports);
                        url.searchParams.append("page", req.page);
                        url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, SalesPaginatedListReportMapper(result.data)];
                }
            });
        });
    };
    SalesReportingRepo.prototype.getReportParamsData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result, reportEntity;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesReportingURL.getParticularReportParamsData);
                        url.searchParams.append("Id", req.reportId);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        reportEntity = {
                            isview: false,
                            isdownload: false,
                            filterJson: undefined,
                            mandatoryFields: [],
                            adminKpiFilterData: undefined,
                        };
                        if (result && result.data) {
                            reportEntity = result.data;
                        }
                        return [2 /*return*/, reportEntity];
                }
            });
        });
    };
    SalesReportingRepo.prototype.getAllReport = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesReportingURL.AllReport);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, SalesAllReportMapper(result.data)];
                }
            });
        });
    };
    SalesReportingRepo.prototype.getHolidayList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesReportingURL.HolidayListApi);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, SalesHolidayListMapper(result.data)];
                }
            });
        });
    };
    SalesReportingRepo.prototype.getMTFReportingDetails = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesReportingURL.MTFReport);
                        url.searchParams.append("filterData", req.filterData);
                        url.searchParams.append("isDownload", String(req.isDownload));
                        url.searchParams.append("page", req.page.toString());
                        url.searchParams.append("pageSize", req.pageSize.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, SalesMTFReportMapper(result.data)];
                }
            });
        });
    };
    SalesReportingRepo.prototype.getMTFReportingDownloadData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result, downloadMTFdata;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesReportingURL.MTFReport);
                        url.searchParams.append("filterData", req.filterData);
                        url.searchParams.append("isDownload", String(req.isDownload));
                        url.searchParams.append("page", req.page.toString());
                        url.searchParams.append("pageSize", req.pageSize.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        downloadMTFdata = {
                            downloadBase64String: result.data,
                        };
                        return [2 /*return*/, downloadMTFdata];
                }
            });
        });
    };
    SalesReportingRepo.prototype.getRmPartnerReportDropdownList = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesReportingURL.dropdownList);
                        url.searchParams.append("ddlid", req.ddlid.toString());
                        if (req === null || req === void 0 ? void 0 : req.userinput)
                            url.searchParams.append("userinput", req.userinput.toString());
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SalesReportingRepo.prototype.getSearchedClientJWTToken = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesReportingURL.clientReport);
                        url.searchParams.append("AccCode", req.AccCode);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        data = {
                            jwtToken: result.data,
                        };
                        return [2 /*return*/, data];
                }
            });
        });
    };
    SalesReportingRepo.prototype.getZeroisingLabel = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesReportingURL.zeroisingLabel);
                        if (req.Id)
                            url.searchParams.append("Id", req.Id);
                        if (req.EqCo)
                            url.searchParams.append("EqCo", req.EqCo);
                        if (req.tentativeFinal)
                            url.searchParams.append("tentativeFinal", req.tentativeFinal);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SalesReportingRepo.prototype.getZeroisingReportIbeats = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesReportingURL.Ibeats);
                        if (req.EqCo)
                            url.searchParams.append("EqCo", req.EqCo);
                        if (req.tentativeFinal)
                            url.searchParams.append("tentativeFinal", req.tentativeFinal);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    SalesReportingRepo.prototype.getZeroisingPopUpView = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesReportingURL.ZeroisingPopupView);
                        if (req.EqCo)
                            url.searchParams.append("EqCo", req.EqCo);
                        if (req.tentativeFinal)
                            url.searchParams.append("tentativeFinal", req.tentativeFinal);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    SalesReportingRepo.prototype.getZeroisingPopUpPublish = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesReportingURL.ZeroisingPopupPublish);
                        if (req.EqCo)
                            url.searchParams.append("EqCo", req.EqCo);
                        if (req.tentativeFinal)
                            url.searchParams.append("tentativeFinal", req.tentativeFinal);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    SalesReportingRepo.prototype.getRmPartnerReportTableColumnHeader = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(salesReportingURL.tableHeader);
                        url.searchParams.append("kpiId", req.kpiId);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    SalesReportingRepo.prototype.getRmPartnerReportTableClickEvent = function (req) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
        return __awaiter(this, void 0, void 0, function () {
            var url, result, response, tableBody, response;
            return __generator(this, function (_2) {
                switch (_2.label) {
                    case 0:
                        url = new URL(salesReportingURL.tableclick);
                        if (req === null || req === void 0 ? void 0 : req.page)
                            url.searchParams.append("page", req.page);
                        if (req === null || req === void 0 ? void 0 : req.pageSize)
                            url.searchParams.append("pageSize", req.pageSize);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _2.sent();
                        if (typeof ((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.data) === "string") {
                            response = {
                                isSucess: result.data.isSucess,
                                message: (_b = result === null || result === void 0 ? void 0 : result.data) === null || _b === void 0 ? void 0 : _b.message,
                                data: (_c = result === null || result === void 0 ? void 0 : result.data) === null || _c === void 0 ? void 0 : _c.data,
                                nextTablePayload: (_d = result === null || result === void 0 ? void 0 : result.data) === null || _d === void 0 ? void 0 : _d.nextTablePayload,
                            };
                            return [2 /*return*/, response];
                        }
                        else if (typeof ((_e = result === null || result === void 0 ? void 0 : result.data) === null || _e === void 0 ? void 0 : _e.data) !== "string") {
                            tableBody = {
                                currentpage: (_h = (_g = (_f = result === null || result === void 0 ? void 0 : result.data) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.datas) === null || _h === void 0 ? void 0 : _h.currentPage,
                                pagesize: (_l = (_k = (_j = result === null || result === void 0 ? void 0 : result.data) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.datas) === null || _l === void 0 ? void 0 : _l.pageSize,
                                totalitems: (_p = (_o = (_m = result === null || result === void 0 ? void 0 : result.data) === null || _m === void 0 ? void 0 : _m.data) === null || _o === void 0 ? void 0 : _o.datas) === null || _p === void 0 ? void 0 : _p.totalItems,
                                totalpages: (_s = (_r = (_q = result === null || result === void 0 ? void 0 : result.data) === null || _q === void 0 ? void 0 : _q.data) === null || _r === void 0 ? void 0 : _r.datas) === null || _s === void 0 ? void 0 : _s.totalPages,
                                tabledata: (_v = (_u = (_t = result === null || result === void 0 ? void 0 : result.data) === null || _t === void 0 ? void 0 : _t.data) === null || _u === void 0 ? void 0 : _u.datas) === null || _v === void 0 ? void 0 : _v.result,
                            };
                            response = {
                                isSucess: result.data.isSucess,
                                message: (_w = result === null || result === void 0 ? void 0 : result.data) === null || _w === void 0 ? void 0 : _w.message,
                                data: {
                                    headers: (_y = (_x = result === null || result === void 0 ? void 0 : result.data) === null || _x === void 0 ? void 0 : _x.data) === null || _y === void 0 ? void 0 : _y.headers,
                                    isSearchable: (_0 = (_z = result === null || result === void 0 ? void 0 : result.data) === null || _z === void 0 ? void 0 : _z.data) === null || _0 === void 0 ? void 0 : _0.isSearchable,
                                    datas: tableBody,
                                },
                                nextTablePayload: (_1 = result === null || result === void 0 ? void 0 : result.data) === null || _1 === void 0 ? void 0 : _1.nextTablePayload,
                            };
                            return [2 /*return*/, response];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SalesReportingRepo.prototype.getGuestTokenAndEmbed = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(supersetReportingURL.GetGuestTokenAndEmbed);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    return SalesReportingRepo;
}());
export default SalesReportingRepo;
